module.exports = __webpack_public_path__ + "img/cbg.c44e7c4c.png";